import React from 'react';
import styled from 'styled-components';

import { Cell, Container, Grid } from '@zeiss/ods-components-react';

import { Text } from '../../../../components';
import { StyledHeadline, StyledMainDescription } from '../../styled';
import { useSlider } from '../../../../hooks';

export const StyledAboutContainer = styled.div`
  display: flex;
  padding: 40px 0 0;
  video {
    width: 100%;
    height: 100%;
  }
`;

export const StyledDescription = styled.div`
  padding-left: 24px;
`;

const Concert = ({
  title,
  description,
  index,
}: {
  description: string;
  index: number;
  title: string;
}) => {
  const ref = React.createRef<HTMLVideoElement>();

  const { activeSlide } = useSlider();
  React.useEffect(() => {
    if (ref.current && index !== activeSlide) {
      ref.current.pause();
      ref.current.currentTime = 0;
    }
  }, [activeSlide, ref]);
  return (
    <StyledAboutContainer>
      <Grid>
        <Container.FullBleed>
          <Cell.Basic colStarts={2} colSpan={7}>
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <video ref={ref} src="./videos/Concert-Video.mp4" controls>
              <source src="./videos/Concert-Video.mp4" type="video/mp4" />
            </video>
          </Cell.Basic>
          <Cell.Basic colSpan={3}>
            <StyledDescription>
              <Grid>
                <Container.FullBleed>
                  <Cell.MaxWidth>
                    <StyledHeadline headline={title} />
                  </Cell.MaxWidth>
                  <Cell.MaxWidth>
                    <StyledMainDescription size="l">
                      {description}
                    </StyledMainDescription>
                  </Cell.MaxWidth>
                  <Cell.MaxWidth>
                    <Text size="m">
                      World premiere on Wed, November 02, 2022
                    </Text>
                  </Cell.MaxWidth>
                  <Cell.MaxWidth>
                    <Text size="m">
                      Emmanuel Witzthum »The Contour of Stars«, (2022), for
                      flute, clarinet, trumpet, trombone, 2 violas, and 2
                      cellos, 22’
                    </Text>
                  </Cell.MaxWidth>
                  <Cell.MaxWidth>
                    <Text size="m">
                      The internationally renowned live coder Flor de Fuego will
                      accompany the ensemble’s guest performance at ZKM |
                      Karlsruhe with visuals generated in real time, allowing
                      the experimental form of notation to be experienced
                      sensually.
                    </Text>
                  </Cell.MaxWidth>
                </Container.FullBleed>
              </Grid>
            </StyledDescription>
          </Cell.Basic>
        </Container.FullBleed>
      </Grid>
    </StyledAboutContainer>
  );
};

export default Concert;
